<template>
  <v-card flat rounded="lg">
    <v-card-text>
      <v-select
        :items="getFiliaisCarregar()"
        no-data-text="Nenhuma filial encontrada"
        label="Selecione a filial"
        v-model="novopedido.filial"
        item-text="descricao"
        item-value="filial"
        hide-details=""
        :disabled="novopedido.produtos.length > 0"
      >
        <template v-slot:item="{ item }">
          {{ item.filial }} - {{ item.descricao }}
        </template>
        <template v-slot:selection="{ item }">
          {{ item.filial }} - {{ item.descricao }}
        </template>
      </v-select>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("pedidos", ["novopedido"]),
    ...mapState("base", ["filiais"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  methods: {
    getFiliaisCarregar() {
      return this.filiais.filter((f) => f.filial > 0);
    },
  },
  mounted() {
    if (
      this.filiais.findIndex((f) => f.filial == this.usuarioLogado.filial) >= 0
    ) {
      this.novopedido.filial = this.usuarioLogado.filial;
    } else {
      this.novopedido.filial = this.getFiliaisCarregar()[0].filial;
    }
  },
};
</script>

<style>
</style>